// @ts-nocheck
import {
  Box,
  Button,
  Text,
  VStack,
  HStack,
  Radio,
  RadioGroup,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
  Input,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  FormErrorMessage,
} from '@chakra-ui/react';
import { Formik, Field, Form } from 'formik';
import axios from 'axios';
import qs from 'qs';
import { useEffect, useState } from 'react';
import useScreen from '../hooks/useScreen';
import {
  number as YupNumber,
  object as YupObject,
  string as YupString,
} from 'yup';
import TextField from './TextField';

const RSVP: React.FC = () => {
  const { isMobile } = useScreen();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [view, setView] = useState<'form' | 'accepted' | 'declined'>('form');

  const schema = YupObject().shape({
    // name: YupString().required('Full name is required.'),
    attending: YupString().required(),
    noOfGuests: YupNumber().min(1).default(1),
    guest1: YupString().test(
      'guest1-required-if-at-least-1',
      "Guest 1's full name is required.",
      function (value) {
        const { noOfGuests } = this.parent;
        if (noOfGuests >= 1) {
          return !!value?.trim();
        }
        return true;
      }
    ),
    guest2: YupString().test(
      'guest2-required-if-at-least-2',
      "Guest 2's full name is required.",
      function (value) {
        const { noOfGuests } = this.parent;
        if (noOfGuests >= 2) {
          return !!value?.trim();
        }
        return true;
      }
    ),
    guest3: YupString().test(
      'guest3-required-if-at-least-3',
      "Guest 3's full name is required.",
      function (value) {
        const { noOfGuests } = this.parent;
        if (noOfGuests >= 3) {
          return !!value?.trim();
        }
        return true;
      }
    ),
    guest4: YupString().test(
      'guest4-required-if-at-least-4',
      "Guest 4's full name is required.",
      function (value) {
        const { noOfGuests } = this.parent;
        if (noOfGuests >= 4) {
          return !!value?.trim();
        }
        return true;
      }
    ),
    guest5: YupString().test(
      'guest5-required-if-at-least-4',
      "Guest 5's full name is required.",
      function (value) {
        const { noOfGuests } = this.parent;
        if (noOfGuests >= 5) {
          return !!value?.trim();
        }
        return true;
      }
    ),
  });

  useEffect(() => {
    return () => {
      onClose();
    };
  }, [onClose]);

  return (
    <>
      <Button
        onClick={onOpen}
        variant="outline"
        color="white"
        borderRadius={0}
        mt={8}
        letterSpacing="3px"
        fontSize="md"
      >
        RSVP
      </Button>

      <Formik
        initialValues={{
          // name: '',
          attending: 'Yes',
          noOfGuests: 1,
          guest1: '',
          guest2: '',
          guest3: '',
          guest4: '',
          guest5: '',
        }}
        validationSchema={schema}
        onSubmit={async (values) => {
          const onSubmit = () => {
            if (values.attending === 'Yes') {
              setView('accepted');
            } else {
              setView('declined');
            }
          };

          try {
            const data = {
              'entry.1363396963': values.guest1,
              'entry.868837582': values.attending,
              'entry.1658283666': values.noOfGuests,
              'entry.689889793':
                values.noOfGuests === 1 ? values.guest1 : values.guest1,
              'entry.420026429': values.noOfGuests === 2 ? values.guest2 : '',
              'entry.1844878816': values.noOfGuests === 3 ? values.guest3 : '',
              'entry.317597105': values.noOfGuests === 4 ? values.guest3 : '',
              'entry.1919384949': values.noOfGuests === 5 ? values.guest3 : '',
              submissionTimestamp: Date.now(),
            };

            await axios.post(
              'https://docs.google.com/forms/d/e/1FAIpQLSfhP3U5hgQND_Waul2z2pAYSgcI6nsSh3SYP7tQSlhctnGiRw/formResponse',
              qs.stringify(data),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
              }
            );
          } catch (e) {
            console.log('debug error', e);
          }

          onSubmit();
        }}
      >
        {({ handleSubmit, errors, touched, ...formikProps }) => {
          return (
            <Modal isOpen={isOpen} onClose={onClose}>
              <ModalOverlay />
              <ModalContent
                w={isMobile ? 'auto' : '400px'}
                mb={0}
                {...(isMobile
                  ? { pos: 'fixed', left: 4, right: 4, bottom: 4 }
                  : {})}
                overflow={'scroll'}
                maxH="80vh"
              >
                <ModalCloseButton />
                <ModalBody p={8}>
                  {view === 'form' && (
                    <>
                      <Text
                        mt={8}
                        w="full"
                        textAlign="center"
                        fontSize={'52px'}
                        letterSpacing={12}
                        fontFamily="TheSeasons"
                        color="#313e60"
                      >
                        RSVP
                      </Text>
                      <Text
                        fontStyle="italic"
                        w="full"
                        textAlign="center"
                        fontSize="xs"
                      >
                        Kindly respond by 30th August
                      </Text>
                    </>
                  )}

                  {view === 'accepted' ? (
                    renderAccept()
                  ) : view === 'declined' ? (
                    renderDecline()
                  ) : (
                    <Form onSubmit={handleSubmit}>
                      {/* <Box mt={8}>
                        <TextField
                          name="name"
                          label="Your full name"
                          formikProps={formikProps}
                          errors={errors}
                          placeholder="Enter your full name"
                        />
                      </Box> */}

                      <Box mt={8}>
                        <Field name="attending">
                          {({ field, ...fieldProps }) => {
                            return (
                              <FormControl>
                                <RadioGroup
                                  {...field}
                                  onChange={(v) => {
                                    formikProps.setFieldValue('attending', v);
                                  }}
                                  value={formikProps.values.attending}
                                >
                                  <VStack alignItems="left">
                                    <Radio value="Yes" name="attending">
                                      Yes! I wouldn't miss it!
                                    </Radio>

                                    <Radio value="No" name="attending">
                                      No. Sorry to miss it!
                                    </Radio>
                                  </VStack>
                                </RadioGroup>
                                {/* <FormErrorMessage>{errors.option}</FormErrorMessage> */}
                              </FormControl>
                            );
                          }}
                        </Field>
                      </Box>

                      {formikProps.values.attending === 'Yes' && (
                        <Box mt={8}>
                          <Field name="noOfGuests">
                            {(fieldProps) => {
                              return (
                                <FormControl>
                                  <FormLabel>
                                    Number of guests attending:
                                  </FormLabel>
                                  <Slider
                                    flex="1"
                                    focusThumbOnChange={false}
                                    value={formikProps.values.noOfGuests}
                                    onChange={(v) => {
                                      formikProps.setFieldValue(
                                        'noOfGuests',
                                        v
                                      );
                                    }}
                                    min={1}
                                    max={5}
                                  >
                                    <SliderTrack>
                                      <SliderFilledTrack bg="#313e60" />
                                    </SliderTrack>
                                    <SliderThumb
                                      fontSize="sm"
                                      boxSize="32px"
                                      children={formikProps.values.noOfGuests}
                                    />
                                  </Slider>
                                </FormControl>
                              );
                            }}
                          </Field>
                        </Box>
                      )}

                      {Array.from(
                        { length: formikProps.values.noOfGuests },
                        (_, i) => (
                          <Box mt={8}>
                            <TextField
                              key={i}
                              name={`guest${i + 1}`}
                              label={`Guest ${i + 1} full name`}
                              formikProps={formikProps}
                              errors={errors}
                              placeholder={`Enter Guest ${i + 1} full name`}
                            />
                          </Box>
                        )
                      )}
                    </Form>
                  )}
                </ModalBody>

                {view === 'form' && (
                  <ModalFooter>
                    <HStack spacing={0} justifyContent="center" w="full" pb={4}>
                      <Button
                        flex={1}
                        variant="outline"
                        mr={3}
                        onClick={onClose}
                        borderRadius={0}
                        isDisabled={formikProps.isSubmitting}
                        fontSize="sm"
                      >
                        Close
                      </Button>
                      <Button
                        borderRadius={0}
                        flex={1}
                        bgColor="#313e60"
                        color="#fff"
                        onClick={formikProps.submitForm}
                        isDisabled={formikProps.isSubmitting}
                        fontSize="sm"
                      >
                        Submit
                      </Button>
                    </HStack>
                  </ModalFooter>
                )}
              </ModalContent>
            </Modal>
          );
        }}
      </Formik>
    </>
  );

  function renderAccept() {
    return (
      <>
        <Text mb={0} mt={4} fontSize="2xl">
          Thanks for your RSVP!
        </Text>
        <Text mb={4} mt={1} fontSize="sm">
          If you need to make any changes, feel free to submit the form again —
          we'll go with your latest response.
        </Text>
        <Text fontStyle="italic" mb={8} fontSize="xs">
          This form is for guests who received a formal invitation.{' '}
          <strong>Submissions will be reviewed and confirmed.</strong> Thank you
          for understanding as we keep our celebration intimate.
        </Text>
      </>
    );
  }

  function renderDecline() {
    return (
      <>
        <Text mb={0} mt={4} fontSize="2xl">
          Thanks for your RSVP!
        </Text>
        <Text mb={4} mt={1} fontSize="sm">
          We’re sorry you won’t be able to join us. If you change your mind,
          you're welcome to submit the form again — we'll go with your latest
          response.
        </Text>
        <Text fontStyle="italic" mb={8} fontSize="xs">
          This form is for guests who received a formal invitation.{' '}
          <strong>Submissions will be reviewed and confirmed.</strong> Thank you
          for understanding as we keep our celebration intimate.
        </Text>
      </>
    );
  }
};

export default RSVP;
